const data = [{
        id: 1,
        title: "Weather App",
        icon_classname: "uil uil-cloud-sun",
        description: "Designed an Weather App, which fetches the user location and shows the weather results for that location.Implemented another functionality to allow user to search for the weather conditions of any city in the world",
        link : "https://weatherapp-blaze.netlify.app/",
        images: [require("../../Assets/TechStack/HTML.png"), require("../../Assets/TechStack/CSS.png"), require("../../Assets/TechStack/Javascript.png")]
    },
    {
        id: 2,
        title: "Food Encyclopedia",
        icon_classname: "uil uil-restaurant",
        description: "Designed an Weather App, which fetches the user location and shows the weather results for that location.Implemented another functionality to allow user to search for the weather conditions of any city in the world",
        link: "https://soubhik752blaze.github.io/FoodEncyclopedia/",
        images: [require("../../Assets/TechStack/HTML.png"), require("../../Assets/TechStack/CSS.png"), require("../../Assets/TechStack/React.png")]
    },
    {
        id: 3,
        title: "Shoppee - An Ecommerce App",
        icon_classname: "uil uil-shopping-bag",
        description: "Create the front end for a e-commerce website, which allows users to add and remove items to/from cart and buy them. Used Redux state management to keep track of the cart items and also implemented Dark and light modes theme option",
        link: "https://shoppee-byblaze.netlify.app/",
        images: [require("../../Assets/TechStack/Redux.png"), require("../../Assets/TechStack/CSS.png"), require("../../Assets/TechStack/React.png"), require("../../Assets/TechStack/Javascript.png")]
    },
    // {
    //     id: 3,
    //     title: "Daily Word Enhancer",
    //     icon_classname: "uil uil-book-open",
    //     description: "Created a Vocabulary Enhancer that teaches the user a new word every hour of the day through notifications in the notifications window, thus helping the user learn new words and enhance his/her vocabulary",
    //     link: "https://github.com/Soubhik752blaze/Daily-Vocabulary-Enhancer",
    //     images: [require("../../Assets/TechStack/Python.png")]
    // },
    {
        id: 4,
        title: "Password Generator",
        icon_classname: "uil uil-key-skeleton",
        description: "Designed a password generator which creates a random password for a user depending on few criterias chosen by the user. Also, shows the overall strength of the generated password and has the added functionality of copying the generated password to the clipboard",
        link: "https://passwordgenerator-blaze.netlify.app/",
        images: [require("../../Assets/TechStack/HTML.png"), require("../../Assets/TechStack/CSS.png"), require("../../Assets/TechStack/Javascript.png")]
    }
]

export default data;